import React from 'react';
import AmplitudeContext from './AmplitudeContext';
import config from '../../config/index';

const keyByEnvironment = {
  development: 'd3cb3e791154775441ca58300a584984',
  staging: 'd3cb3e791154775441ca58300a584984',
  production: '8e7eaa2f690c015263a2c54abb6f01a4'
};

const serverSideClient = {
  logEvent: () => null,
  setUserId: () => null,
  setUserProperties: () => null
};

export default function AmplitudeProvider({ children, stub = false }) {
  let client = serverSideClient;
  if (process.browser && !stub) {
    const amplitude = require('amplitude-js/amplitude');
    amplitude.init(keyByEnvironment[config.environment || 'development'], undefined, {
      includeReferrer: true,
      includeUtm: true
    });
    client = amplitude;
  }
  return <AmplitudeContext.Provider value={client}>{children}</AmplitudeContext.Provider>;
}
